import * as yup from 'yup';

import {
    emailValidationRule,
    firstNameValidationRule,
    lastNameValidationRule,
} from './validationRules';

export const emailSchema = yup.object({
    email: emailValidationRule,
});

export const accountDetailsSchema = yup.object({
    firstName: firstNameValidationRule,
    lastName: lastNameValidationRule,
    age: yup
        .number()
        .optional()
        //.positive('Please enter a valid age')
        .transform((value) => (isNaN(value) ? undefined : value)),
    gender: yup.string().optional(),
});

export const locationSchema = yup.object({
    zip: yup
        .string()
        .required("ZIP code can't be blank")
        .transform((value) => value || undefined),
});

export const brokerDetailFormSchema = yup.object({
    brokerageLicenseNumber: yup
        .string()
        .transform((value) => value || undefined),
    brokerageName: yup.string().transform((value) => value || undefined),
    housesSold: yup.string().transform((value) => value || undefined),
    averageHomeValue: yup.string().transform((value) => value || undefined),
    yearsExperience: yup.string().transform((value) => value || undefined),
});
